import { useState } from 'react';

const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d9u4gun8l97n3eas3h5g';

export default function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = (form.querySelector('input[name="mobile_alt"]') as HTMLInputElement)?.value || '';
    if (honeypot.trim()) {
      setStatus('success');
      setMessage('提交成功，我们会尽快回复你！');
      form.reset();
      return;
    }

    setStatus('loading');
    try {
      const formData = new FormData(form);
      const response = await fetch(CONTACT_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      const serverMsg = parsed?.meta?.message || parsed?.message || '';

      if (response.ok && (!parsed || parsed.code === 'OK')) {
        setStatus('success');
        setMessage('感谢你的留言！我们会尽快回复。');
        form.reset();
      } else if (serverMsg.includes('spam')) {
        setStatus('error');
        setMessage('提交失败，请稍后再试');
      } else {
        setStatus('error');
        setMessage(serverMsg || '提交失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section className="py-16 md:py-20 px-6 md:px-10">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 leading-relaxed">
            有任何问题、建议或合作意向，欢迎随时与我们联系
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-1 space-y-5">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                <i className="ri-mail-line"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-950 mb-1">电子邮箱</p>
                <a href="mailto:hello@bareskinlab.com" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                  hello@bareskinlab.com
                </a>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                <i className="ri-map-pin-line"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-950 mb-1">办公地址</p>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  上海市静安区南京西路1266号<br />恒隆广场2座18层
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                <i className="ri-phone-line"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-950 mb-1">联系电话</p>
                <p className="text-sm text-foreground-500 whitespace-nowrap">021-6288-XXXX</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-2">
            <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form="">
              <input
                type="text"
                name="mobile_alt"
                className="spam-guard"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="contact-name" className="block text-sm text-foreground-700 mb-1.5">
                    姓名 <span className="text-red-400">*</span>
                  </label>
                  <input
                    id="contact-name"
                    type="text"
                    name="name"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="你的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm text-foreground-700 mb-1.5">
                    邮箱 <span className="text-red-400">*</span>
                  </label>
                  <input
                    id="contact-email"
                    type="email"
                    name="email"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="your@email.com"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="contact-subject" className="block text-sm text-foreground-700 mb-1.5">
                  主题
                </label>
                <input
                  id="contact-subject"
                  type="text"
                  name="subject"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="留言主题（选填）"
                />
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-sm text-foreground-700 mb-1.5">
                  留言 <span className="text-red-400">*</span>
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="请输入你的留言，我们会尽快回复（500字以内）"
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
              </div>
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap"
              >
                {status === 'loading' ? '提交中...' : '发送留言'}
              </button>
              {message && (
                <p className={`text-sm ${status === 'success' ? 'text-accent-700' : 'text-red-500'}`}>
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}